import React from 'react'
import SocialMediaLinks from 'cwp-components/SocialMediaLinks/SocialMediaLinks'

interface BannerProps {
  title: string
  imgSrc: string
}

const Banner = ({ title, imgSrc }: BannerProps) => {
  return (
    <div className='relative template-area w-full md:mt-[-20px] md:min-h-[466px] h-auto'>
      <div className='px-7 lg:px-10 xl:px-16 2xl:px-20 box-border'>
        <div className='pt-5 pb-20 md:pb-5'>
          <div className='pt-13 md:pt-19 flex flex-col md:flex-row items-center gap-4'>
            <div className='w-full md:w-5/12'>
              <div className='h-100 w-full max-w-[762px]'>
                <h3 className='text-2xl lg:text-4xl xl:text-5xl 2xl:text-6xl font-bold text-[#122D5C] leading-none'>
                  {title}
                </h3>
                <p className='text-xs sm:text-sm md:text-base lg:text-lg font-bold text-[#001A3D] leading-6 tracking-wide mt-3 mb-5 md:my-3'>
                  Dive into this legal field and discover its many specialised
                  branches.
                </p>
                <SocialMediaLinks />
              </div>
            </div>
            <div className='w-full md:w-7/12 '>
              {imgSrc && (
                <img
                  src={imgSrc}
                  alt={`Image illustrating ${title}`}
                  className='h-[200px] object-cover flex bg-[#101828] w-full max-w-[480px] ml-auto'
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Banner
